import { render, staticRenderFns } from "./SSelectTaskProject.vue?vue&type=template&id=5d6e8611"
import script from "./SSelectTaskProject.vue?vue&type=script&lang=js"
export * from "./SSelectTaskProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports